document.addEventListener('DOMContentLoaded', () => {
  const marquees = document.querySelectorAll('.announcement-bar__marquee');

  marquees.forEach((marquee) => {
    const track = marquee.querySelector('.announcement-bar__marquee-track');
    const content = marquee.querySelector('.announcement-bar__marquee-content');

    if (!track || !content) return;

    const clone = content.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');

    track.appendChild(clone);
  });
});